import React, { Component } from 'react';
import Fecha from 'fecha';


import * as Constants from '../../../constants/constants'
import { Row, Col, Collapse } from 'react-bootstrap'
import Tooltip from "../../template/tooltip.js"
import i18n from '../../../i18n';
import { Trans } from 'react-i18next';

const marginRemove = {
	marginLeft: "0px",
	marginRight: "0px"
}

const titleStyle = {
	backgroundColor: Constants.MAIN_COLOR2,
	color: "#fff",
	fontWeight: "bold",
	marginLeft: "0px",
	marginRight: "0px"
}

const padding = {
	padding: "15px",
	wordWrap: "break-word"
}

const leftClass = "col-lg-3 col-sm-3 col-4 border";
const rightClass = "col-lg-9 col-sm-9 col-8 border";
const sIdClass = "col-lg-1 col-sm-1 col-2 d-flex justify-content-center align-self-center"

export default class Signature extends Component {

	constructor(props) {
		super(props);
		this.state = {
			open: false,
		};
	}

	render() {
		var url = window.location.href;
		var splittedUrl = url.split("/");

		if (splittedUrl[splittedUrl.length - 1] == "phone") {
			var lang = splittedUrl[splittedUrl.length - 2];
		} else {
			var lang = splittedUrl[splittedUrl.length - 1];
		}
		if (lang == 1) {
			var signingTime = Fecha.format(new Date(this.props.data.signingTime), 'DD.MM.YYYY. [u] HH:mm');
			var bestSignatureTime = Fecha.format(new Date(this.props.data.bestSignatureTime), 'DD.MM.YYYY. [u] HH:mm');
		} else if (lang == 2) {
			var signingTime = Fecha.format(new Date(this.props.data.signingTime), 'DD.MM.YYYY. [at] HH:mm');
			var bestSignatureTime = Fecha.format(new Date(this.props.data.bestSignatureTime), 'DD.MM.YYYY. [at] HH:mm');
		}

		/* console.log(this.props.data.indication); */

		return (
			<React.Fragment>

				<Row tabIndex="0" role="button" style={titleStyle} className="border-top" onClick={() => this.setState({ open: !this.state.open })} onKeyUp={this.props.handleKeyUp}>
					<Col style={padding} className="col-lg-12 col-sm-12 col-12">
						<Row style={marginRemove}>
							<Col className="col-lg-11 col-sm-11 col-10">
								<Row>
									<Col style={{ "paddingLeft": "5px" }} className="col-3">
										{i18n.t("docInfo:signature_seal_id")}
									</Col>
									<Col className="col-9">
										{this.props.index + 1}. {this.props.data.id}
									</Col>
								</Row>
							</Col>
							<Col className={sIdClass} style={{ "paddingRight": "0px" }}>
								{this.state.open ?
									<i className="material-icons align-middle" aria-hidden="true">expand_less</i>
									:
									<i className="material-icons align-middle" aria-hidden="true">expand_more</i>
								}
							</Col>
						</Row>
					</Col>
				</Row>

				<Collapse in={this.state.open}>
					<div>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>{i18n.t("simple:signature_level") + ":"}</Col>
							<Col style={padding} className={rightClass}>
								<span className="align-middle">{i18n.t("simple:" + this.props.data.signatureLevel.description)}</span>
								<Tooltip trigger={['focus', 'hover']} placement="auto" tooltip={i18n.t("simple:" + this.props.data.signatureLevel.description + "_exp")}>
									<i className="material-icons align-middle" style={{ "marginLeft": "10px" }}>info</i>
								</Tooltip>
							</Col>
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>{i18n.t("simple:indication")}</Col>
							<Col style={padding} className={rightClass}>
								<span style={{ "fontWeight": "bold", "color": indicationColor(this.props.data.indication) }} className="align-middle">{i18n.t("simple:" + this.props.data.indication)}</span>
								<Tooltip trigger={['focus', 'hover']} placement="auto" tooltip={i18n.t("simple:" + this.props.data.indication + "_exp")}>
									<i className="material-icons align-middle" style={{ "marginLeft": "10px" }}>info</i>
								</Tooltip>
							</Col>
						</Row>

						{this.props.data.subIndication != null ?
							<Row style={marginRemove}>
								<Col style={padding} className={leftClass}>{i18n.t("simple:subindication")}</Col><Col style={padding} className={rightClass}>{this.props.data.subIndication}</Col>
							</Row>
							:
							null
						}

						{this.props.data.errors.length != 0 ?
							<Row style={marginRemove}>
								<Col style={padding} className={leftClass}>{i18n.t("simple:errors")}</Col><Col style={padding} className={rightClass}>
									{this.props.data.errors.map((errors, i) => {
										return <div key={i} style={{ "color": Constants.RED }}><Trans>{i18n.t("detailed:" + errors)}</Trans></div>
									})}
								</Col>
							</Row>
							:
							null
						}

						{this.props.data.warnings.length != 0 ?
							<Row style={marginRemove}>
								<Col style={padding} className={leftClass}>{i18n.t("simple:warnings")}</Col><Col style={padding} className={rightClass}>
									{this.props.data.warnings.map((warnings, i) => {
										return <div key={i} style={{ "color": Constants.ORANGE }}>{i18n.t("detailed:" + warnings)}</div>
									})}
								</Col>
							</Row>
							:
							null
						}

						{this.props.data.infos.length != 0 ?
							<Row style={marginRemove}>
								<Col style={padding} className={leftClass}>{i18n.t("simple:infos")}</Col><Col style={padding} className={rightClass}>
									{this.props.data.infos.map((infos, i) => {
										return <div key={i}>{i18n.t("detailed:" + infos)}</div>
									})}
								</Col>
							</Row>
							:
							null
						}

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>{i18n.t("simple:signature_format") + ":"}</Col>
							<Col style={padding} className={rightClass}>
								<span className="align-middle">{i18n.t("simple:" + this.props.data.signatureFormat)}</span>
								<Tooltip trigger={['focus', 'hover']} placement="auto" tooltip={i18n.t("simple:" + this.props.data.signatureFormat + "_exp")}>
									<i className="material-icons align-middle" style={{ "marginLeft": "10px" }}>info</i>
								</Tooltip>
							</Col>
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>{i18n.t("simple:certificate_chain")}</Col><Col style={padding} className={rightClass}>
								{this.props.data.certificateChain.certificate.map((certificate, i) => {
									return <div key={i}>{certificate.qualifiedName}</div>
								})}
							</Col>
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>{i18n.t("simple:on_claimed_time")}</Col>
							<Col style={padding} className={rightClass}>
								<span className="align-middle">{signingTime}</span>
								<Tooltip trigger={['focus', 'hover']} placement="auto" tooltip={i18n.t("simple:on_claimed_time_exp")}>
									<i className="material-icons align-middle" style={{ "marginLeft": "10px" }}>info</i>
								</Tooltip>
							</Col>
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>{i18n.t("simple:best_signature_time")}</Col><Col style={padding} className={rightClass}><span className="align-middle">{bestSignatureTime}</span>
								<Tooltip trigger={['focus', 'hover']} placement="auto" tooltip={i18n.t("simple:best_signature_time_exp")}>
									<i className="material-icons align-middle" style={{ "marginLeft": "10px" }}>info</i>
								</Tooltip>
							</Col>
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>{i18n.t("simple:signature_position")}</Col>
							<Col style={padding} className={rightClass}>
								<span className="align-middle">{this.props.index + 1}{i18n.t("simple:out_of")}{this.props.signaturesCount}</span>
								<Tooltip trigger={['focus', 'hover']} placement="auto" tooltip={i18n.t("simple:signature_position_exp")}>
									<i className="material-icons align-middle" style={{ "marginLeft": "10px" }}>info</i>
								</Tooltip>
							</Col>
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>{i18n.t("simple:signature_scope")}</Col>
							<Col style={padding} className={rightClass}>
								{this.props.data.signatureScope.map((signatureScope, i) => {
									return <div key={i}>
										<div>
											<span>{signatureScope.name} ({signatureScope.scope})</span>
											<Tooltip trigger={['focus', 'hover']} placement="auto" tooltip={i18n.t("simple:signature_scope_exp")}>
												<i className="material-icons align-middle" style={{ "marginLeft": "10px" }}>info</i>
											</Tooltip>
										</div>
										<div>{signatureScope.value}</div>
									</div>
								})}


							</Col>
						</Row>

					</div>
				</Collapse>
			</React.Fragment >
		);
	}
}

function indicationColor(tIndication) {
	if (tIndication == "TOTAL_PASSED" || tIndication == "PASSED") {
		return Constants.GREEN;
	} else if (tIndication == "INDETERMINATE") {
		return Constants.ORANGE;
	} else if (tIndication == "TOTAL_FAILED" || tIndication == "FAILED") {
		return Constants.RED;
	}
	return Constants.WHITE;
}